export var OptionType = /*#__PURE__*/ function(OptionType) {
    OptionType["User"] = "user";
    OptionType["Group"] = "group";
    return OptionType;
}({});
